export default __webpack_public_path__ + "static/media/wrong.baf0dd75.mp3";